// =====================================================================
// surgeryService (PME Sprint 4 / S52) — galeria de cirurgia plástica
// (fotos antes/depois). 🔒 LGPD: imagens servidas auth-gated (blob+token).
// =====================================================================
import api from "./api";

export const PHASE_OPTIONS = [
  { value: "preop", label: "Pré-operatório" },
  { value: "intraop", label: "Intraoperatório" },
  { value: "postop_d1", label: "Pós-op 1 dia" },
  { value: "postop_d7", label: "Pós-op 7 dias" },
  { value: "postop_d30", label: "Pós-op 30 dias" },
  { value: "postop_d90", label: "Pós-op 90 dias" },
  { value: "postop_d365", label: "Pós-op 1 ano" }
];

export const ANGLE_OPTIONS = [
  { value: "front", label: "Frente" },
  { value: "left", label: "Esquerda" },
  { value: "right", label: "Direita" },
  { value: "top", label: "Superior" },
  { value: "bottom", label: "Inferior" }
];

export const PHASE_LABELS = PHASE_OPTIONS.reduce((m, o) => ((m[o.value] = o.label), m), {});
export const ANGLE_LABELS = ANGLE_OPTIONS.reduce((m, o) => ((m[o.value] = o.label), m), {});

// ordem das fases pra montar a sequência antes -> depois
export const PHASE_ORDER = PHASE_OPTIONS.reduce((m, o, i) => ((m[o.value] = i), m), {});

export const uploadSurgeryPhoto = async (patientId, file, fields = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  if (fields.procedureName) fd.append("procedureName", fields.procedureName);
  if (fields.phase) fd.append("phase", fields.phase);
  if (fields.angle) fd.append("angle", fields.angle);
  if (fields.notes) fd.append("notes", fields.notes);
  if (fields.takenAt) fd.append("takenAt", fields.takenAt);
  const { data } = await api.post(`/patients/${patientId}/surgery-photos`, fd);
  return data;
};

export const listSurgeryPhotos = async (patientId) => {
  const { data } = await api.get(`/patients/${patientId}/surgery-photos`);
  return data; // { photos: [...] }
};

export const getSurgeryPhotoObjectUrl = async (id) => {
  const { data } = await api.get(`/ehr/surgery-photos/${id}`, { responseType: "blob" });
  return URL.createObjectURL(data);
};

export const deleteSurgeryPhoto = async (id) => {
  await api.delete(`/ehr/surgery-photos/${id}`);
};

export const SURGERY_ACCEPT = "image/png,image/jpeg,image/jpg,image/webp";
export const SURGERY_MAX_BYTES = 10 * 1024 * 1024;

export const validateSurgeryPhotoFile = (file) => {
  if (!file) return "Selecione uma imagem.";
  const ok = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
  if (!ok.includes(file.type)) return "Formato inválido. Use PNG, JPG ou WEBP.";
  if (file.size > SURGERY_MAX_BYTES) return "Imagem muito grande (máx. 10 MB).";
  return null;
};

export const surgeryErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_PHOTO_TOO_LARGE: "Imagem muito grande (máx. 10 MB).",
    ERR_UPLOAD_MIMETYPE: "Formato inválido. Use PNG, JPG ou WEBP.",
    ERR_PHOTO_FILE_REQUIRED: "Selecione uma imagem.",
    ERR_PATIENT_NOT_FOUND: "Paciente não encontrado.",
    ERR_PHOTO_NOT_FOUND: "Foto não encontrada."
  };
  if (code && map[code]) return map[code];
  return "Não foi possível concluir a operação. Tente novamente.";
};
